import React from 'react';
import PageNotFoundIllustration from '../assets/Illustrations/illustration_404';
import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
import Page from './Page';
import { getHostedNetworkIP } from '../utils/getHostedNetworkIP';
import { useNavigate } from 'react-router-dom';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));
const Page404 = () => {
  const navigate = useNavigate();
  return (
    <Page title="404 Page Not Found" sx={{ height: 1, minHeight: '100vh' }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center', marginTop: '-2rem' }}>
            <m.div>
              <Typography variant="h3" paragraph>
                Sorry, page not found!
              </Typography>
            </m.div>
            <Typography sx={{ color: 'text.secondary' }}>
              Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check
              your spelling.
            </Typography>

            <m.div>
              <PageNotFoundIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </m.div>
            <Button onClick={() => navigate('/')} size="large" variant="contained">
              Go to Home
            </Button>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
};

export default Page404;
